















import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import AvidiaStatements from "@/employee/components/landing-pages/avidia/Statements.vue";
import HsaBankStatements from "@/employee/components/landing-pages/hsabank/Statements.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { Home } from "@/employee/route-names";
import { BankCustodian } from "@/admin/types";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    AvidiaStatements,
    HsaBankStatements,
    GenericLoadingSpinner,
  }
})
export default class Statements extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();

  @Prop()
  year: number;

  created () {
    this.custodianSettingsStore.getCustodianSettings();
    this.onLoaded();
  }

  get isLoading () {
    return !this.custodianSettingsStore.isLoaded || !this.featureFlagStore.featureFlagsLoadedState;
  }

  get showAvidia () {
    return this.custodianSettingsStore.userCustodian === BankCustodian.Avidia;
  }

  get showHsaBank () {
    return this.custodianSettingsStore.isHsaBankCustodian;
  }

  @Watch("isLoading")
  onLoaded () {
    if (!this.isLoading && !this.showHsaBank && !this.showAvidia) {
      // this page should not be shown, redirect to home
      this.$router.push({ name: Home });
    }
  }
}

